<section role="region" aria-labelledby="client-create-heading">
	<h2 id="client-create-heading" lvrPadding [padHorizontal]="32" [padVertical]="0">
		{{ 'workplace.create_workplace.title' | transloco }}
	</h2>
	<form
		class="form-container"
		[formGroup]="newWorkplaceForm"
		autocomplete="on"
		lvrAutoSave="workplace"
		[entityId]="draftId"
		[autoLoad]="false"
	>
		<section class="form-grid">
			<div>
				<!-- name -->
				<lvr-field [label]="'base.field.name' | transloco | appendAsterisk">
					@let nameCtrl = newWorkplaceForm.get('name');
					<mat-form-field lvrInput [lvrError]="hasError(nameCtrl, 'pattern', 'required')">
						<input
							matInput
							formControlName="name"
							[placeholder]="'base.field.workplace_placeholder' | transloco"
							[errorStateMatcher]="matcher"
						/>
						@if (hasError(nameCtrl, 'pattern')) {
							<mat-error>{{ 'base.form.error.branch_name_invalid' | transloco }}</mat-error>
						}
						@if (hasError(nameCtrl, 'required')) {
							<mat-error>{{ 'base.form.error.name_required' | transloco }}</mat-error>
						}
					</mat-form-field>
				</lvr-field>

				<!--Branche field-->
				@if (user().roles?.id === eaaRole) {
					<lvr-branch-field formControlName="industryName" class="branch-field"></lvr-branch-field>
				}
			</div>

			<lvr-field class="align-items">
				<!-- Address Field -->
				<lvr-address-completion
					[showAsterisk]="true"
					class="address-completion"
					formControlName="address"
				></lvr-address-completion>
			</lvr-field>
		</section>

		<!-- Contact Points Field -->
		@for (item of communicationPointCountArrayKeys(); track $index) {
			<section class="form-grid">
				<h3 lvrPadding class="additional-communication-heading" [padVertical]="0" [padHorizontal]="8">
					@if (communicationPointCount() > 1) {
						<span>{{ 'base.field.contact_point.title' | transloco }}</span>
						<button matIconButton class="btn btn-tertiary" type="button" (click)="removeContactPoint($index)">
							<mat-icon class="material-symbols-outlined" aria-hidden="true">delete</mat-icon>
						</button>
					} @else {
						<span>{{ 'base.field.contact_point.title' | transloco }}</span>
					}
				</h3>
				<lvr-contact-point
					[contactPointCategories]="contactPointCategories()"
					class="address-completion"
					(values)="updateValues($event, $index)"
				></lvr-contact-point>
			</section>
		}
		<!-- Add additional button -->
		@if (communicationPointCountArrayKeys().length < 5) {
			<section class="form-grid">
				<lvr-button
					variant="primary"
					[label]="'base.field.contact_point.title' | transloco"
					[ariaLabel]="'base.field.contact_point.add_communication' | transloco"
					[type]="'button'"
					(clicked)="addContactPoint()"
					icon="add"
				></lvr-button>
			</section>
		}

		<p class="required-hint">{{ 'base.form.required' | transloco }}</p>

		<lvr-default-actions
			[disableSave]="newWorkplaceForm.invalid || !canEditInstitutionsPermission()"
			[showLoading]="saving()"
			(save)="createWorkplace()"
			(cancelSave)="cancel()"
		>
			<lvr-restore-actions entityType="workplace" [entityId]="draftId"></lvr-restore-actions>
		</lvr-default-actions>
	</form>
</section>
